export default __webpack_public_path__ + "static/media/aboutUsSectionImg1.41e1f649.jfif";